import { DOPPEL_BUTTON_GREY, DOPPEL_LIGHT_GREY, DOPPEL_WHITE } from '@/utils/style'
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import { HStack, IconButton } from '@chakra-ui/react'
import { ReactElement } from 'react'

type DropdownPaginationButtonsProps = {
  pageIndex: number
  totalCount: number
  handlePageChange: (newPage: number) => void
  pageSize: number
}

function DropdownPaginationButtons({
  pageIndex,
  totalCount,
  handlePageChange,
  pageSize,
}: DropdownPaginationButtonsProps): ReactElement {
  return (
    <HStack>
      <IconButton
        _hover={{ background: DOPPEL_LIGHT_GREY }}
        aria-label="left button"
        bgColor={DOPPEL_BUTTON_GREY}
        color={DOPPEL_WHITE}
        icon={<ChevronLeftIcon />}
        isDisabled={pageIndex === 0}
        onClick={() => handlePageChange(pageIndex - 1)}
        size={'sm'}
      ></IconButton>

      <IconButton
        _hover={{ background: DOPPEL_LIGHT_GREY }}
        aria-label="right button"
        bgColor={DOPPEL_BUTTON_GREY}
        color={DOPPEL_WHITE}
        icon={<ChevronRightIcon />}
        isDisabled={pageIndex === Math.ceil(totalCount / pageSize) - 1}
        onClick={() => handlePageChange(pageIndex + 1)}
        size={'sm'}
      ></IconButton>
    </HStack>
  )
}

export default DropdownPaginationButtons
